import JSONAPISerializer from '@ember-data/serializer/json-api';
import { underscore } from '@ember/string';

export default class PersonSerializer extends JSONAPISerializer {
  keyForAttribute(attr) {
    return underscore(attr);
  }

  //   serialize() {
  //     let json = super.serialize(...arguments);
  //     json.data.attributes.settings = {
  //       show_uncertainties: json.data.attributes.show_uncertainties,
  //       show_wfa: json.data.attributes.show_wfa,
  //     };

  //     delete json.data.attributes.show_uncertainties;
  //     delete json.data.attributes.show_wfa;

  //     return json;
  //   }
}
